
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/doelpunt-van-de-week",
      function () {
        return require("private-next-pages/doelpunt-van-de-week.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/doelpunt-van-de-week"])
      });
    }
  